module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_NL-cf1680d7f425a82efb680947cc618017.svg";